export const documentExtensions = ['doc', 'docx', 'docb', 'docm', 'dot', 'dotm', 'dotx', 'odt', 'ott', 'stw', 'sxw'];
export const powerPointExtensions = [
  'pot',
  'potm',
  'potx',
  'ppam',
  'pps',
  'ppsx',
  'ppt',
  'pptm',
  'pptx',
  'sld',
  'sldx',
];
export const excelExtensions = [
  'xla',
  'xlam',
  'xll',
  'xlm',
  'xls',
  'xlsb',
  'xslm',
  'xlsx',
  'xlt',
  'xltm',
  'xltx',
  'xlw',
];
export const textExtensions = ['csv', 'json', 'pdf', 'rtf', 'txt', 'text', 'tsv', 'xml'];
export const imageExtensions = ['bmp', 'gif', 'jpeg', 'jpg', 'png', 'tif', 'tiff'];

export const fileExtensions = [
  ...documentExtensions,
  ...powerPointExtensions,
  ...excelExtensions,
  ...textExtensions,
  ...imageExtensions,
];
